<template>
  <v-container class="layout-container pa-0">
    <SenderSettings />

    <Feature
      v-slot="{ feature }"
      :feature-slug="featureNames.COMPANY"
    >
      <div v-if="company">
        <v-divider class="my-4" />
        <SalutationSettings
          :company="company"
          :showUpselling="!feature.config.isSalutationEditable"
          @refetchCompany="refetchCompany"
        />
      </div>
    </Feature>

    <v-divider class="my-4" />
    <DomainSettings />

    <v-divider
      v-if="company"
      class="my-4"
    />
    <SignatureSettings
      v-if="company"
      :company="company"
      :googleReviewLink="settings?.company?.googleReviewLink ?? null"
      :provenExpertLink="settings?.company?.provenExpertLink ?? null"
      @refetchCompany="refetchCompany"
    />
  </v-container>
</template>

<script>
import feature from '@/mixins/feature'
import GET_GOOGLE_REVIEW_SETTINGS from '@/modules/settings/emailSettings/queries/GetGoogleReviewSettings.gql'

import DomainSettings from './DomainSettings.vue'
import COMPANY from './queries/Company.gql'
import SalutationSettings from './SalutationSettings.vue'
import SenderSettings from './SenderSettings.vue'
import SignatureSettings from './SignatureSettings.vue'
export default {
  components: {
    DomainSettings,
    SenderSettings,
    SalutationSettings,
    SignatureSettings,
  },
  mixins: [feature],
  methods: {
    refetchCompany() {
      this.$apollo.queries.company.refetch()
    },
    refetchSettings() {
      this.$apollo.queries.settings.refetch()
    },
  },
  apollo: {
    company: {
      query: COMPANY,
      variables() {
        return {
          id: this.$auth.user.companyId,
        }
      },
    },
    settings: {
      query: GET_GOOGLE_REVIEW_SETTINGS,
      variables() {
        return {
          companyId: this.$auth.user.companyId,
        }
      },
    },
  },
}
</script>
